/**
 * <AbsenceQuotaNotice> — l'encadré « Absences » d'une absence qu'on s'apprête à signaler (molecule).
 *
 * Il dit, AVANT de confirmer, si l'absence sera rattrapée : oui, et ce qui restera sur la période ;
 * non, et pourquoi (moins de 2 h, quota atteint, séance déjà de rattrapage). Alerte quand le quota
 * est atteint. Les phrases : `absenceQuotaMessage` (Wajih, 24/10).
 *
 * Compose `<AlertCard>` : aucune surface à lui.
 */
import React from "react"

import { type UIAbsenceQuota } from "../../../ports/primary/ui/types"
import { type Voice } from "../../utils/voice"
import { AlertCard } from "../AlertCard"
import { absenceQuotaMessage } from "./absenceQuotaMessage"

/**
 * Ce que le formulaire legacy dit d'une absence qui ne se rattrapera pas : elle se signale quand
 * même. Phrase impersonnelle, la même dans les deux voix — lue par l'étape « Trop tard » de
 * l'élève ; l'encadré ne la reprend pas, le bouton le dit déjà.
 */
export const ABSENCE_STILL_REPORTABLE_HINT =
    "Il est toujours possible de signaler l'absence pour prévenir le masteur, mais la séance ne pourra pas être rattrapée."

const TITLE = "Absences"

export type AbsenceQuotaNoticeProps = {
    quota: UIAbsenceQuota
    /** À qui l'encadré parle — `"parent"` par défaut. */
    voice?: Voice
    /** Voix parent : le prénom de l'enfant. Absent, l'encadré dit « votre enfant ». */
    childFirstname?: string
    testID?: string
}

export function AbsenceQuotaNotice(props: AbsenceQuotaNoticeProps) {
    const { quota, voice = "parent", childFirstname, testID } = props
    const { severity, message } = absenceQuotaMessage(quota, voice, childFirstname)
    return <AlertCard severity={severity} title={TITLE} message={message} testID={testID} />
}
